'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowRepeat = function TiArrowRepeat(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.5 11.7h-3.5l2.2-2.2c0.6-0.6 0.6-1.7 0-2.3s-1.7-0.7-2.4 0l-6.2 6.1 6.2 6.2c0.3 0.3 0.8 0.5 1.2 0.5s0.9-0.2 1.2-0.5c0.6-0.6 0.6-1.7 0-2.3l-2.2-2.2h3.5c2.3 0 4.2 2.2 4.2 5s-2.3 5-5 5c-1 0-1.7 0.7-1.7 1.7s0.7 1.6 1.7 1.6c4.6 0 8.3-3.7 8.3-8.3s-3.4-8.3-7.5-8.3z m-13.7 8.8c-0.6 0.6-0.6 1.7 0 2.3l2.2 2.2h-3.5c-2.3 0-4.2-2.2-4.2-5s2.3-5 5-5c1 0 1.7-0.7 1.7-1.7s-0.7-1.6-1.7-1.6c-4.6 0-8.3 3.7-8.3 8.3s3.4 8.3 7.5 8.3h3.5l-2.2 2.2c-0.6 0.6-0.6 1.7 0 2.3 0.3 0.4 0.8 0.5 1.2 0.5s0.9-0.1 1.2-0.5l6.2-6.1-6.2-6.2c-0.7-0.7-1.7-0.7-2.4 0z' })
        )
    );
};

exports.default = TiArrowRepeat;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-repeat.js
// module id = 3533
// module chunks = 0